export default {
  /**
   * UI router instance
   * @type {Router}
   */
  router: null,

  /**
   * UI routes
   * @type {Array[Route]}
   */
  routes: [],

  /**
   * Initial route requested when application was loaded
   * @type {Route}
   */
  initialRoute: null,

  /**
   * Current route
   * @type {Route}
   */
  currentRoute: null,

  /**
   * Previous route
   * @type {Route}
   */
  previousRoute: null,

  /**
   * Status of current navigation
   * @type {Object}
   */
  navigating: {
    /**
     * Source route
     * @type {Route}
     */
    from: null,
    /**
     * Target route
     * @type {Route}
     */
    to: null,
    /**
     * Time when navigation started
     * @type {Date}
     */
    startedAt: null,
    /**
     * Time when navigation ended
     * @type {Date}
     */
    finishedAt: null
  }
}

